<script>
	const _ = require('underscore');
	const metadata = require('core/metadata');
	const model = require('model/model');

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const { setStudentSettings, setHideStudentLibraryPromo } = studentLibraryUtilities;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_SETTINGS_OPEN = analyticsUtilities.events.SL_SETTINGS_OPEN;
	const SL_SETTINGS_CLOSE = analyticsUtilities.events.SL_SETTINGS_CLOSE;
	const SL_UPDATE_SKF = analyticsUtilities.events.SL_UPDATE_SKF;
	const SL_UPDATE_THEME = analyticsUtilities.events.SL_UPDATE_THEME;

	const { assetUrl } = require('utilities/urlUtilities');

	const SPACE = 'space';
	const BTS = 'back-to-school';
	const GLBL = 'global';
	const FLOW = 'flow';
	const GRN = 'green';
	const GRP = 'grape';

	let themeList = [SPACE, BTS, GLBL, FLOW, GRN, GRP];

	let themeConfig = {
		[SPACE]: {
			id: SPACE,
			name: 'Lunar Landing',
			img: 'lunar-landing.jpg'
		},
		[BTS]: {
			id: BTS,
			name: 'Back To School',
			img: 'back-to-school.jpg'
		},
		[GLBL]: {
			id: GLBL,
			name: 'Global Citizen',
			img: 'global-citizen.jpg'
		},
		[FLOW]: {
			id: FLOW,
			name: 'Pattern Flow',
			img: 'pattern-flow.jpg'
		},
		[GRN]: {
			id: GRN,
			name: 'Green Goblin',
			img: 'green.jpg'
		},
		[GRP]: {
			id: GRP,
			name: 'Purple People Eater',
			img: 'purple.jpg'
		}
	};
	module.exports = {
		components: {
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'heart-icon': require('components/svg/heart-icon.vue').default,
			'bookmark-icon': require('components/svg/bookmark-icon.vue').default,
			'checkbox-icon': require('components/svg/checkbox-icon.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default
		},
		props: ['loading'],
		modelData: ['studentLibrarySettings', 'userContext'],
		data() {
			return {
				settingsLoading: false,
				pageIdx: 0,
				themeList,
				themeConfig,
				initial: false,
				tts: false
			};
		},
		computed: {
			pages() {
				let p = ['topics', 'theme'];
				if (this.initial) {
					p.push('tips');
				}
				return p;
			},
			viewLoading() {
				let loading = this.loading;
				let settingsLoading = this.settingsLoading;

				return loading || settingsLoading;
			},
			currentPage() {
				let pageIdx = this.pageIdx;
				let pages = this.pages;
				let current = null;

				if (typeof pageIdx === 'number' && pages && pages.length) {
					current = pages[pageIdx];
				}
				return current;
			},
			selectedInterests() {
				let studentLibrarySettings = this.studentLibrarySettings;
				let g = {};
				if (studentLibrarySettings && studentLibrarySettings.g) {
					g = studentLibrarySettings.g;
				}
				return g;
			},
			// interests() {
			// 	let genres = metadata.genresById;
			// 	let selectedInterests = this.selectedInterests;
			// 	return Object.keys(genres)
			// 		.map(mid => {
			// 			let g = genres[mid];
			// 			return _.assign({}, g, {
			// 				id: g.rms_key,
			// 				text: g.name,
			// 				selected: selectedInterests[g.rms_key]
			// 			});
			// 		});
			// },
			selectedTopics() {
				let studentLibrarySettings = this.studentLibrarySettings;
				let skf = {};
				if (studentLibrarySettings && studentLibrarySettings.skf) {
					skf = studentLibrarySettings.skf;
				}
				return skf;
			},
			topics() {
				let skf = metadata.skfById;
				let selectedTopics = this.selectedTopics;
				let topics = Object.keys(skf).map(mid => {
					let g = skf[mid];
					return _.assign({}, g, {
						id: g.rms_key,
						text: g.name,
						selected: selectedTopics[g.rms_key]
					});
				});
				return topics;
			},
			selectedTheme() {
				let studentLibrarySettings = this.studentLibrarySettings;
				let t = '';
				if (studentLibrarySettings && studentLibrarySettings.t) {
					t = studentLibrarySettings.t;
				}
				return t;
			},
			themes() {
				let selectedTheme = this.selectedTheme;
				return themeList.map(id => {
					return _.assign({}, themeConfig[id], {
						selected: id === selectedTheme
					});
				});
			}
		},
		watch: {
			pageIdx(val, oldVal) {
				let pages = this.pages;
				let pageKey = typeof oldVal === 'number' && pages[oldVal] ? this.pages[oldVal] : null;
				if (pageKey) {
					this.persistSettings(pageKey);
				}
			}
		},
		methods: {
			nextPage() {
				if (this.pageIdx < this.pages.length - 1) {
					this.pageIdx++;
				}
			},
			previousPage() {
				if (this.pageIdx > 0) {
					this.pageIdx--;
				}
			},
			persistSettings(pageKey) {
				let isTeacher = this.userContext && !this.userContext.classCode;
				if (!isTeacher) {
					if (pageKey === 'topics') {
						this.saveTopics();
					} else if (pageKey === 'theme') {
						this.saveTheme();
					}
				}
			},
			onTopicClick(topic) {
				let studentLibrarySettings = this.studentLibrarySettings || {};
				let skf = this.selectedTopics;

				if (skf[topic.id]) {
					skf = Object.keys(skf).reduce((acc, key) => {
						if (key !== String(topic.id)) {
							acc[key] = true;
						}
						return acc;
					}, {});
				} else {
					skf = _.assign({}, skf, {
						[topic.id]: true
					});
				}

				model.set(
					'studentLibrarySettings',
					_.assign({}, studentLibrarySettings, {
						skf
					})
				);
			},
			saveTopics() {
				let t = undefined;
				let g = this.selectedInterests;
				let skf = this.selectedTopics;
				let studentLibrarySettings = this.studentLibrarySettings || {};

				this.settingsLoading = true;
				fireEvent(SL_UPDATE_SKF, {
					skf: Object.keys(skf).map(s => Number(s))
				});
				model.set(
					'studentLibrarySettings',
					_.assign({}, studentLibrarySettings, {
						skf
					})
				);
				setStudentSettings(t, g, skf).finally(() => {
					this.settingsLoading = false;
					setHideStudentLibraryPromo();
				});
			},
			onThemeClick(theme) {
				let studentLibrarySettings = this.studentLibrarySettings || {};

				if (theme && theme.id) {
					model.set(
						'studentLibrarySettings',
						_.assign({}, studentLibrarySettings, {
							t: theme.id
						})
					);
				}
			},
			saveTheme() {
				let t = this.selectedTheme;
				let g = undefined;
				let skf = undefined;

				if (t && t.length) {
					this.settingsLoading = true;
					fireEvent(SL_UPDATE_THEME, {
						theme: t
					});
					this.onThemeClick(t);
					setStudentSettings(t, g, skf).finally(() => {
						this.settingsLoading = false;
						setHideStudentLibraryPromo();
					});
				}
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-library-settings') {
					return true; // let some other handler take this
				}

				if (opts.initial) {
					this.initial = opts.initial;
				}

				fireEvent(SL_SETTINGS_OPEN);
				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-library-settings') {
					return true; // let some other handler take this
				}
				let settings = this.studentLibrarySettings;
				let hasSettings = !!settings && (!!settings.skf || !!settings.t);

				if (hasSettings && this.pageIdx === 0) {
					let pageKey = this.pages[this.pageIdx];
					if (pageKey) {
						this.persistSettings(pageKey);
					}
				}

				this.initial = false;
				this.pageIdx = 0;

				fireEvent(SL_SETTINGS_CLOSE);
				return false;
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	#modal-library-settings {
		.modal-content-header {
			position: relative;

			.tts-button {
				position: absolute;
				top: -0.6rem;
				right: 2rem;
				padding: 0.25rem 1.25rem;

				&.active {
					background-color: $c-blue;
					color: $c-white;
				}
			}
		}

		.interests {
			text-align: left;

			h3 {
				text-align: center;
			}

			.input-item-with-label {
				width: 50%;
				display: inline-block;
				margin-bottom: 0.5rem;
				padding-right: 0.5rem;

				label.input-label {
					align-items: baseline;
				}
			}
		}

		.theme {
			.theme-list {
				display: flex;
				flex-wrap: wrap;

				.theme-option {
					flex-basis: 50%;
					display: inline-block;
					text-align: center;
					font-weight: bold;
					padding: 0.5rem 0;
					cursor: pointer;

					img.theme-img {
						display: block;
						margin: 0 auto;
					}

					&:hover {
						background: $c-blue;
						border: 1px solid $c-grey;
					}

					&.active {
						background: $c-blue;
						border: 1px solid $c-blue;
					}
				}
			}
		}

		.tips {
			p {
				display: flex;
				text-align: left;
				align-items: center;

				.icon-container {
					height: 70px;
					width: 70px;
					border-radius: 35px;
					margin-right: 1rem;
					padding: 0.25rem;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-shrink: 0;

					&.bookmark {
						background-color: $c-teal;
					}

					&.heart {
						background-color: $c-purple;
					}

					&.recommendation {
						background-color: $c-pastel-yellow;
					}
				}

				svg {
					position: relative;
					stroke-width: 3px;

					&.heart-icon {
						stroke: lighten($c-red, 30%);
						width: 35px;
					}

					&.bookmark-icon {
						stroke: $c-white;
					}

					&.checkbox-icon {
						fill: $c-purple;
					}
				}

				&.lets-go {
					margin-top: 1rem;
					justify-content: center;
				}
			}
		}

		.wizard-body {
			display: flex;

			.wizard-page-button-container {
				display: flex;
				align-items: center;
				padding: 0 1rem;
				cursor: pointer;

				.wizard-page-button {
					padding: 0.5rem;

					&:hover {
						color: $c-blue;
					}

					// border: 1px solid #dcdee0;
					// border-radius: 5rem;
					// padding: .25rem 0.75rem;
					// line-height: 0rem;
					// width: 0;
				}

				&.disabled {
					cursor: default;

					.wizard-page-button,
					.wizard-page-button:hover {
						color: $c-slate-muted;
					}
				}
			}

			.wizard-content {
				flex: 1;
				padding-bottom: 2rem;
			}
		}

		.pagination-circle {
			font-size: 0.75rem;
			color: $c-slate-muted;
			margin-right: 0.5rem;
			cursor: pointer;

			&.active {
				color: $c-blue-dark;
			}

			&:hover,
			&:focus {
				color: $c-slate-dark;
			}
		}
	}
</style>
<template>
	<modal
		ref="modal"
		id="modal-library-settings"
		:loading="viewLoading"
		wide
		centered>
		<template slot="header-container">
			<h2 v-if="initial">
				Set Up Your Library
				<text-to-speech-player-simple
					v-if="tts"
					@click.native.stop.prevent
					:text="'Set Up Your Library'"></text-to-speech-player-simple>
			</h2>
			<h2 v-if="!initial">
				Library Settings
				<text-to-speech-player-simple
					v-if="tts"
					@click.native.stop.prevent
					:text="'Library Settings'"></text-to-speech-player-simple>
			</h2>
			<button
				class="tts-button button -outline"
				:class="{
					active: tts
				}"
				@click="tts = !tts"
				aria-label="Toggle text-to-speech">
				<i
					class="fa-solid fa-volume-high"
					aria-hidden="true"></i>
			</button>
		</template>
		<div
			slot="content"
			class="library-settings-body">
			<div class="wizard-body">
				<button
					class="wizard-page-button-container wizard-page-back button -link"
					:class="{
						disabled: pageIdx === 0
					}"
					:disabled="pageIdx === 0"
					@click="previousPage"
					aria-label="Previous page">
					<div class="wizard-page-button page-back-button">
						<i
							class="fa-solid fa-chevron-left"
							aria-hidden="true"></i>
					</div>
				</button>
				<div
					v-if="currentPage === 'topics'"
					class="wizard-content interests">
					<h3>
						What topics interest you?
						<text-to-speech-player-simple
							v-if="tts"
							@click.native.stop.prevent
							:text="'What topics interest you?'"></text-to-speech-player-simple>
					</h3>
					<input-item-with-label
						v-for="topic in topics"
						:key="topic.text"
						:item="topic"
						:on-item-click="onTopicClick">
						<text-to-speech-player-simple
							v-if="tts"
							@click.native.stop.prevent
							:text="topic.text"></text-to-speech-player-simple>
					</input-item-with-label>
				</div>
				<div
					v-if="currentPage === 'theme'"
					class="wizard-content theme">
					<h3>
						Choose a library theme:
						<text-to-speech-player-simple
							v-if="tts"
							@click.native.stop.prevent
							:text="'Choose a library theme'"></text-to-speech-player-simple>
					</h3>
					<div class="theme-list">
						<button
							v-for="theme in themes"
							:key="theme.name"
							class="theme-option button -link"
							:class="{
								active: theme.selected
							}"
							@click="onThemeClick(theme)">
							<img
								:alt="`${theme.name} Theme`"
								class="theme-img"
								:src="assetUrl('/assets/dist/images/library/' + theme.img)" />
						</button>
					</div>
				</div>
				<div
					v-if="currentPage === 'tips'"
					class="wizard-content tips">
					<h3>
						Use these features to get the most out of your library:
						<text-to-speech-player-simple
							v-if="tts"
							@click.native.stop.prevent
							text="Use these features to get the most out of your library"></text-to-speech-player-simple>
					</h3>
					<p>
						<span class="icon-container bookmark">
							<bookmark-icon></bookmark-icon>
						</span>
						<span>
							Add passages to your Reading List
							<text-to-speech-player-simple
								v-if="tts"
								@click.native.stop.prevent
								text="Add Passages to Your reading List"></text-to-speech-player-simple>
						</span>
					</p>
					<p>
						<span class="icon-container recommendation">
							<checkbox-icon></checkbox-icon>
						</span>
						<span>
							Keep track of what you've read
							<text-to-speech-player-simple
								v-if="tts"
								@click.native.stop.prevent
								text="Keep track of what you've read"></text-to-speech-player-simple>
						</span>
					</p>
					<p>
						<span class="icon-container heart">
							<heart-icon></heart-icon>
						</span>
						<span>
							Save favorite passages
							<text-to-speech-player-simple
								v-if="tts"
								@click.native.stop.prevent
								text="Save Favorite Passages"></text-to-speech-player-simple>
						</span>
					</p>
					<p class="lets-go">
						<button
							class="button"
							data-modal-close>
							Let's Go!
						</button>
					</p>
				</div>
				<button
					class="wizard-page-button-container wizard-page-next button -link"
					:class="{
						disabled: pageIdx === pages.length - 1
					}"
					:disabled="pageIdx === pages.length - 1"
					@click="nextPage"
					aria-label="Next page">
					<div class="wizard-page-button page-next-button">
						<i
							class="fa-solid fa-chevron-right"
							aria-hidden="true"></i>
					</div>
				</button>
			</div>
			<div class="wizard-footer">
				<button
					v-for="(page, idx) in pages"
					:key="page"
					class="button -link pagination-circle"
					:class="{
						active: page === currentPage
					}"
					@click="pageIdx = idx"
					:aria-label="`Go to page ${idx + 1}`"
					:aria-current="page === currentPage ? 'page' : false">
					<i class="fa-solid fa-circle"></i>
				</button>
			</div>
		</div>
	</modal>
</template>
